<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Services Provided in the Intensive Care Unit and Precautions</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Preparation Items</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Doctor's Rounds</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Meal Information</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Patient Visit Guide and Precautions</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Others</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">List of Items Needed for Admission to the Intensive Care Unit</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Services Provided in the Intensive Care Unit and Precautions</h3>
            <p class="bullet04 num1 depth">
                The hospital provides basic nursing care such as suctioning, patient repositioning, partial bathing, urination, bowel management, and feeding assistance.
            </p>
            <p class="bullet04 num2 depth">
                How to call in an emergency: If you need emergency or nursing assistance, press the emergency bell located next to the bed to receive immediate assistance.
            </p>
            <p class="bullet04 num3 depth">
                Room changes within the intensive care unit may occur for infection control and specialized treatment in the unit.
            </p>
            <p class="bullet04 num4 depth">
                <span>
                    To maintain various types of tubes (catheters, drainage tubes, conduits, etc.) and medical devices or equipment that directly affect the patient's respiratory and cardiovascular systems, and to prevent the patient from harming himself or others, the hospital may require the patient to 
                    <span class="font-main">wear a body protector </span> 
                    according to the following procedure. 
                </span>
            </p>
            <p class="bullet05 depth">The attending physician will explain to the patient or guardian the need to wear a body protector, have the patient wear it, and observe the body part on which it is worn at least every two hours.</p>
            <p class="bullet05 depth">
                In emergency situations, medical staff may require the patient to wear the protector before explaining its necessity to the guardian.
            </p>
            <p class="bullet04 num5 depth">
                Please inform the doctor and nurse in charge of any medications that the patient is taking prior to hospitalization. Patients are not allowed to take these medications without consultation.
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Preparation Items</h3>
            <p class=" depth">Please prepare wet wipes, diapers, mats, and masks for the patient.</p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Doctor's Rounds</h3>
            <p class="bullet04 num1 depth">Doctor's rounds are made from 8:00am to 10:00am, but they may vary depending on the circumstances of the department.</p>
            <p class="bullet04 num2 depth">If you want an interview with the doctor during the round, please inform the nurse in charge.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Meal Information</h3>
            <p class="bullet04 num1 depth">Meal times for patients who can eat - Breakfast: 7am-8am; Lunch: 12pm-1pm; Dinner: 6pm- 7 pm.</p>
            <p class="bullet04 num2 depth">If a patient wishes, the patient can choose to receive “special meals” that is not covered by national health insurance, in which case the patient will bear the full cost.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Patient Visit Guide and Precautions</h3>
            <p class="bullet04 num1 depth">Regular visiting hours</p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">Item</th>
                                <th>Weekday</th>
                                <th>Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">Integrated Intensive Care Unit</td>
                                <td>Neurological Intensive Care Unit</td>
                                <td>Every day</td>
                                <td rowspan="4">13:00 to 13:20</td>
                            </tr>
                            <tr>
                                <td>Internal Medicine Intensive Care Unit</td>
                                <td>Every day</td>
                            </tr>
                            <tr>
                                <td rowspan="2">Surgical Intensive Care Unit</td>
                                <td>Surgical Intensive Care Unit</td>
                                <td>Every day</td>
                            </tr>
                            <tr>
                                <td>Cardiovascular Intensive Care Unit</td>
                                <td>Every day</td>
                            </tr>
                            <tr>
                                <td>Aortic Vascular Intensive Care Unit</td>
                                <td>Aortic Vascular Intensive Care Unit</td>
                                <td>Every day</td>
                                <td>12:30 to 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">
                When visiting a patient, the visit may be restricted or delayed depending on the situation in the intensive care unit.
            </p>
            <p class="bullet04 num3 depth">
                For infection control, only 1 visitor is allowed, and switching is not allowed.
            </p>
            <p class="bullet04 num4 depth">
                To ensure patient stability and prevent infection, visits by under 12 years old with weak immune systems or family members suffering from colds or contagious diseases are restricted. Visitors are requested to observe the visiting hours.
            </p>
            <p class="bullet04 num5 depth">
                Before and after the visit, please use hand sanitizer or wash your hands at the sink at the entrance to the intensive care unit.
            </p>
            <p class="bullet04 num6 depth">
                When visiting a patient, please wear the vinyl gown provided at the entrance to the intensive care unit, and remove the gown and wash your hands before leaving the intensive care unit.
            </p>
            <p class="bullet04 num7 depth">
                To prevent the patient from falling during the visit, please observe the following:
            </p>
            <p class="bullet05 depth">Always raise both bed rails.</p>
            <p class="bullet05 depth">If you need assistance, call the nurse.</p>
            <p class="bullet04 num8 depth">
                Cell phones must be turned off in the intensive care unit as radio interference can cause medical equipment to malfunction.
            </p>
            <p class="bullet04 num9 depth">
                If the patient shows any unusual signs (altered consciousness, chest pain, bleeding, or convulsions) during the visit, please notify the medical staff immediately.
            </p>
            <p class="bullet04 num10 depth">
                In the case of pediatric patients, An identity verification procedure may be conducted during the visit to prevent abduction and ensure their safety.
            </p>
            <p class="bullet04 num11 depth">
                Please cooperate by completing the visitor management list
            </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">Others</h3>
            <h4 class="bullet02 type2 num1 depth">Convenience facilities </h4>
            <p class="depth">
                The hospital has an unmanned medical fee payment machine, a video CD registration machine, a convenience store, a bank, a cafe, a food court, a bakery, medical equipment, and an unmanned parcel delivery box.
            </p>

            <h4 class="bullet02 type2 num2 depth">
                Fire prevention and response Measures 
            </h4>
            <p class="depth">
                Please refrain from using portable gas ranges, electric fans, and electric heaters in the family waiting room, and do not bring in any flammable or combustible materials. In the event of a fire, please notify the hospital staff immediately and evacuate the premises via the evacuation room and emergency stairs as instructed by the hospital staff.
            </p>

            <h4 class="bullet02 type2 num3 depth">
                No smoking
            </h4>
            <p class="depth">
                For the health of patients and fire prevention, the entire hospital has been designated as a non-smoking area, so please cooperate by refraining from smoking.
            </p>

            <h4 class="bullet02 type2 num4 depth">
                Complaints and grievance handling 
            </h4>
            <p class="depth">
                If you have any questions, inconveniences, or compliments regarding your use of the hospital’s services, you can inform the hospital by visiting the Customer Satisfaction Center on the first floor, or via phone or the hospital website.
            </p>

            <h4 class="bullet02 type2 num5 depth">
                Parking fees
            </h4>
            <p class="depth">
                Please refer to the parking fee information posted on the bulletin board at the entrance to the intensive care unit.
            </p>

            <h4 class="bullet02 type2 num6 depth">
                Beware of loss and theft
            </h4>
            <p class="depth">
                Valuables and cash cannot be stored in the intensive care unit. Please keep all cash and valuables close by or contact the hospital administration. Please keep all assistive devices such as dentures, hearing aids, glasses, and contact lenses carefully, since they must be removed from your body during examinations, procedures, and surgeries.
                <br>
                The hospital is not responsible for any loss caused by the patient's negligence
            </p>

            <h4 class="bullet02 type2 num7 depth">Belongings Management</h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">Glasses </li>
                <li class="bullet-item">Dentures </li>
                <li class="bullet-item">Hearing aid </li>
                <li class="bullet-item">Wallet </li>
                <li class="bullet-item">Cell phone </li>
                <li class="bullet-item">Clothes </li>
                <li class="bullet-item">Shoes </li>
                <li class="bullet-item">Keys </li>
                <li class="bullet-item">Keys </li>
                <li class="bullet-item">Watch </li>
                <li class="bullet-item">Earrings </li>
                <li class="bullet-item">Necklace </li>
                <li class="bullet-item">Bracelet  </li>
                <li class="bullet-item">Anklet  </li>
                <li class="bullet-item">Other  </li>
                <li class="bullet-item">given to (Name: <span class="gap100"></span>Relationship: <span class="gap100"></span>)</li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">Guide to religious facilities </h4>
            <p class="depth">
                As our hospital is a Christian hospital, the "Bangju Church" on the 3rd floor of Building C holds a Sunday service at 10:00 on Sundays, a Wednesday service at 17:00 on Wednesdays, and a children’s/youth service at 10:00 on Thursdays. For inquiries about ward visits, faith counseling, and other forms of religious counseling, please call the pastoral counseling office (+82-2-6986-5724). The pastoral office and prayer room are located on the 3rd floor of Building C.
            </p>

            <h4 class="bullet02 type2 num9 depth">Guide to the discharge procedure </h4>
            <p class="depth">
                When discharge insurance review is finished, a text message will be sent to the patient or guardian. For discharge payment, please use the hospital admission/discharge window or the self-service payment machine in the hospital administration. After payment, you can pick up your discharge medication from the nurse's office.
            </p>

            <h4 class="bullet02 type2 num10 depth">Issuance of various certificates</h4>
            <p class="depth">
                Please inform your doctor or nurse in advance of any necessary documents such as medical certificates, medical records, and image copies.
            </p>

            <h4 class="bullet02 type2 num11 depth">
                Our hospital respects and protects patients' rights and obligations throughout all treatment processes.
            </h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Patient's Rights</th>
                                <th>Patient's Responsibilities</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Right to receive medical care.</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Obligation of trust and respect for medical professionals.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Right to know and right to self-determination.</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Right to confidentiality.</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Obligation not to receive treatment through improper means.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Right to request consultation and mediation.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Right to receive medical services in a safe medical environment.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">
                If a patient or guardian (visitor) commits an act of violence (verbal abuse, threats, disturbance, sexual violence, sexual harassment, damage to property, etc.) against a member of our medical staff, they may be punished in accordance with the relevant laws and regulations.
            </h4>

            <h4 class="bullet02 type2 num13 depth mt20">
                If a patient or guardian creates a situation that may constitute obstruction of business, insult, defamation or assault against a medical professional, thereby rendering that medical professional unable to carry out his or her medical duties normally, the hospital may refuse to treat the patient (right to refuse treatment) provided that it does not violate the Medical Service Act or the Emergency Medical Service Act.
            </h4>

            <h4 class="bullet02 type2 num14 depth mt20">
                While the patient is hospitalized, the patient's condition is observed via CCTV, but no images are recorded.
            </h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">List of Items Needed for Admission to the Intensive Care Unit</h3>

            <h4 class="bullet02 depth">Visit Guidelines in the Intensive Care Unit</h4>
            <p class="depth">Regular visiting hours in the intensive care unit:  <span class="font-main">12:30pm to 12:50pm</span> every day.</p>

            <h4 class="bullet02 depth">Guidance on Transfer from the Intensive Care Unit to the General Ward </h4>
            <p class="depth">
                When transferring from the intensive care unit to the general ward, a caregiver or guardian who can attend to the patient for 24 hours is needed. For patients who are mobile, please prepare slippers.
            </p>

            <h4 class="bullet02 depth">Other Information</h4>
            <p class="depth">
                Please understand that if an extremely urgent emergency arises, the patient may be transferred to the emergency room at any time at the discretion of the department.
            </p>

            <h4 class="bullet02 depth">Items Needed for the Intensive Care Unit</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">1.	Medications before hospital admission (excluding hospital medications)</p>
                    <p class="bullet04 num2 depth">2.	Diapers (wing type O, panty type X)</p>
                    <p class="bullet04 num3 depth">3.	Mat, wet tissue (large)</p>
                    <p class="bullet04 num4 depth">4.	Vaseline for lips</p>
                    <p class="bullet04 num5 depth">5.	Paper cup, 500ml*2 bottled water (if necessary)</p>
                    <p class="bullet04 num6 depth">6.	If the patient is conscious: Toothbrush, toothpaste, straw cup, tissue box</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">Notice on Prohibition of Storing Valuables in the Intensive Care Unit</h4>
            <p class="depth">
                Personal cell phones cannot be used in the intensive care unit. The hospital is not responsible for lost valuables, so please take all valuables with you. Please inform us if you wear dentures or a hearing aid.
            </p>

            <h4 class="bullet02 depth">Locations for Purchasing Items</h4>
            <p class="bullet03 depth">24-hour convenience store: <span class="font-main">CU Convenience Store, B1</span></p>
            <p class="bullet03 depth">Mon to Fri, 9am-6pm:<span class="font-main">Medical device store, B1</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>